export function formatPrice(price: number): string {
  const [whole, decimal] = Number(price).toFixed(2).split(".");
  const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  let formattedPrice = `${formattedWhole},${decimal}`;
  formattedPrice += " PLN";

  return formattedPrice;
}
